import { FormKitNode } from "@formkit/core";

/**
 * Auto select current year when datepicker input is empty and the user entered the day and month.
 */
const plugin = (node: FormKitNode) => {
  if (node.type === "input" && node.props.type === "datepicker") {
    node.hook.prop((payload, next) => {
      const inputIsString =
        payload.prop === "inputText" && typeof payload.value === "string";

      if (
        !node.value &&
        inputIsString &&
        payload.value.match(/^\d{2}-\d{2}-Y{4}$/)
      ) {
        payload.value =
          payload.value.slice(0, 5) + `-${new Date().getFullYear()}`;
      }

      return next(payload);
    });
  }
};

export default plugin;
